import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import jiologo from './assets/jioLogo.png';
 

import { Provider } from 'react-redux';
import { store } from './storeConfigure';
// import 'react-datepicker/dist/react-datepicker.css';
// import '../styles/login.scss';
$(window).on('load', function() {
  $("#pre-load").delay(600).fadeOut(500);
  $(".pre-loader").delay(600).fadeOut(500);
});

ReactDOM.render(
  // <React.StrictMode>
    <Provider store = {store}>
    <div id="pre-load">
      <div id="loader" className="loader">
        <div className="loader-container">
          <div className="loader-icon">
            <img 
              src={jiologo}
              alt='loader'
            />
          </div>
        </div>
      </div>
    </div>
    <App />
    </Provider>,
    
  // </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
